module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-bg-f98ff71427bea3ee1cdb99136686e5e0.png";